module.exports = __webpack_public_path__ + "static/img/banner_invite2.50faf10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_invite2.png
// module id = 1XZZ
// module chunks = 0